/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerDownLeftIcon64Regular = forwardRef('ArrowDCornerDownLeftIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M43.5 41a9.5 9.5 0 0 0 9.5-9.5v-24a1.5 1.5 0 0 0-3 0v24a6.5 6.5 0 0 1-6.5 6.5H12.39c.07-.093.147-.183.232-.268l14.939-14.938a1.5 1.5 0 1 0-2.121-2.122L10.5 35.611a5.5 5.5 0 0 0 0 7.778L25.44 58.328a1.5 1.5 0 1 0 2.12-2.122L12.623 41.268A2.508 2.508 0 0 1 12.39 41H43.5Z" })));
});
